// AI Generated: Redux store configuration for Home page
import { configureStore } from '@reduxjs/toolkit';
import homeSlice, { homeInitialState } from '$ind/reducers/home.slice';
import { homeApiSlice } from '$ind/api/home.api';

const configureHomeStore = (preloadedState: any = {}) => {
  const store = configureStore({
    reducer: {
      home: homeSlice,
      [homeApiSlice.reducerPath]: homeApiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(homeApiSlice.middleware),
    preloadedState: {
      home: {
        ...homeInitialState,
        ...preloadedState.home,
      },
    },
  });
  return store;
};

export type RootState = ReturnType<ReturnType<typeof configureHomeStore>['getState']>;
export type AppDispatch = ReturnType<typeof configureHomeStore>['dispatch'];

export default configureHomeStore;
// AI Generated: End of home store configuration




